export * from './about.component';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/components/about/index.ts